import {
  BaseAvatar,
  HStack,
  Text,
  View,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import {
  User,
  UserAccountType,
  UserV2,
} from "@towersystems/roam-common/lib/generated-types";
import { useGlobalSettingsProvider } from "../../utilities/global-settings/hooks";
import { toTitleCase } from "../../utilities/to-title-case";

export interface UserAvatarProps {
  user: UserV2;
}

export const UserAvatar = ({ user }: UserAvatarProps) => {
  const { spacings } = useThemeProvider();
  const { businessName } = useGlobalSettingsProvider();

  const name = user.identifier;

  const businessDetailsMarkup = businessName ? (
    <Text numberOfLines={1}>{toTitleCase(businessName)}</Text>
  ) : undefined;

  const formattedFullName = `${toTitleCase(name)}`;

  return (
    <HStack spacing={spacings.s1}>
      <BaseAvatar
        hideName={true}
        initials={name.substring(0, 2).toUpperCase()}
        fullName={formattedFullName}
      />
      <View
        style={{
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Text fontWeight="bold" numberOfLines={1}>
          {formattedFullName}
        </Text>
        {businessDetailsMarkup}
      </View>
    </HStack>
  );
};
